<template>
  <div class="learn-wrap">
    <label class="learn-radio line-btn l-btn">
      <input v-model="chatType" type="radio" name="learn-select" value="CONFERENCE" />
      <div class="icon-box conference">
        <img :src="getAssetImageUrl('common/icons/conference-white.svg')" alt="" />
      </div>
      <p>{{ t('onboarding_conference') }}</p>
    </label>
    <label class="learn-radio line-btn l-btn">
      <input v-model="chatType" type="radio" name="learn-select" value="MEETING" />
      <div class="icon-box meeting">
        <img :src="getAssetImageUrl('common/icons/meeting-white.svg')" alt="" />
      </div>
      <p>{{ t('onboarding_meeting') }}</p>
    </label>
    <label class="learn-radio line-btn l-btn">
      <input v-model="chatType" type="radio" name="learn-select" value="AUDIENCE" />
      <div class="icon-box audience">
        <img :src="getAssetImageUrl('common/icons/audience-white.svg')" alt="" />
      </div>
      <p>{{ t('onboarding_audience') }}</p>
    </label>

    <label class="learn-radio line-btn l-btn">
      <input v-model="chatType" type="radio" name="learn-select" value="GENERAL" />
      <div class="icon-box general">
        <img :src="getAssetImageUrl('common/icons/general-white.svg')" alt="" />
      </div>
      <p>{{ t('onboarding_general') }}</p>
    </label>

    <label class="learn-radio line-btn l-btn">
      <input v-model="chatType" type="radio" name="learn-select" value="SINGLE" />
      <div class="icon-box single">
        <img :src="getAssetImageUrl('common/icons/single-white.svg')" alt="" />
      </div>
      <p>{{ t('onboarding_one_to_one') }}</p>
    </label>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { TypeCall } from '@/types/common';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();

const chatType = defineModel<TypeCall | null>({
  required: true,
  default: null,
});
</script>

<style scoped lang="scss">
input[type='radio'] {
  display: none;
}
.learn-wrap {
  margin: $size-xl 0;
  .learn-radio {
    display: flex;
    align-items: center;
    width: 100%;
    gap: $size-s;
    padding: 0.75rem;
    border: 1px solid $color-gray-40;
    border-radius: $size-s;
    transition: all 0.2s;
    margin-bottom: $size-s;
    &:has(input[type='radio']:checked) {
      border: 1px solid $color-navy-100;
      background: $primary-bg;
      p {
        color: $color-navy-100;
      }
    }
    p {
      font-size: $font-size-psmall;
      font-weight: 500;
      transition: all 0.2s;
    }
    .icon-box {
      width: 28px;
      height: 28px;
      border-radius: $size-s;
      display: flex;
      align-items: center;
      justify-content: center;
      &.conference {
        background: $conference;
      }
      &.meeting {
        background: $meeting;
      }
      &.audience {
        background: $audience;
      }
      &.general {
        background: $general;
      }
      &.single {
        background: $single;
      }
      img {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }
    }
  }
}
</style>
